<template>
  <div>
    <!-- Seção -->
    <div v-if="option.tipo === 'secao'" class="identification-tag">
      {{ option.titulo }}
    </div>
    <!-- Input -->
    <v-text-field
      v-else-if="
        option.tipo !== 'nome' &&
          option.tipo !== 'cpf' &&
          option.tipo !== 'cnpj' &&
          option.tipo !== 'localidade' &&
          option.tipo !== 'email' &&
          option.tipo !== 'multipla_escolha' &&
          option.tipo !== 'data' &&
          option.tipo !== 'caixa_selecao' &&
          option.tipo !== 'lista_suspensa' &&
          option.tipo !== 'resposta_longa' &&
          option.tipo !== 'upload_arquivo' &&
          option.tipo !== 'termo_responsabilidade' &&
          option.tipo !== 'paragrafo' &&
          option.tipo !== 'upload_imagem' &&
          option.tipo !== 'documentos'
      "
      ref="ticketName"
      :mask="getMask(option.tipo)"
      v-model="option.valor"
      :rules="
        option.obrigatorio
          ? [
              rulesValidation.required,
              counterField ? rulesValidation.maxChar : true,
            ]
          : [counterField ? rulesValidation.maxChar : true]
      "
      @keypress.enter="$emit('save')"
      outline
      :return-masked-value="returnMaked(option.tipo)"
      :label="option.obrigatorio ? `${option.titulo} *` : option.titulo"
    ></v-text-field>
    <v-text-field
      v-else-if="option.tipo === 'nome'"
      ref="ticketName"
      v-model="option.valor"
      :rules="
        option.obrigatorio
          ? [
              rulesValidation.required,
              rulesValidation.noSpecialChars,
              counterField ? rulesValidation.maxChar : true,
            ]
          : [
              rulesValidation.noSpecialChars,
              counterField ? rulesValidation.maxChar : true,
            ]
      "
      @keypress.enter="$emit('save')"
      outline
      :label="option.obrigatorio ? `${option.titulo} *` : option.titulo"
    ></v-text-field>
    <v-text-field
      v-if="option.tipo === 'cpf'"
      ref="ticketName"
      :mask="getMask(option.tipo)"
      v-model="option.valor"
      :rules="
        option.obrigatorio ? [rulesValidation.required, cpfRule] : [cpfRule]
      "
      @keypress.enter="$emit('save')"
      outline
      :return-masked-value="returnMaked(option.tipo)"
      :label="option.obrigatorio ? `${option.titulo} *` : option.titulo"
    ></v-text-field>
    <v-text-field
      v-if="option.tipo === 'cnpj'"
      ref="ticketName"
      :mask="getMask(option.tipo)"
      v-model="option.valor"
      :rules="
        option.obrigatorio ? [rulesValidation.required, cnpjRule] : [cnpjRule]
      "
      @keypress.enter="$emit('save')"
      outline
      :return-masked-value="returnMaked(option.tipo)"
      :label="option.obrigatorio ? `${option.titulo} *` : option.titulo"
    ></v-text-field>
    <v-text-field
      v-if="option.tipo === 'email'"
      ref="ticketName"
      type="email"
      :mask="getMask(option.tipo)"
      v-model="option.valor"
      :rules="
        option.obrigatorio
          ? [
              rulesValidation.required,
              rulesValidation.email,
              rulesValidation.maxChar,
            ]
          : [rulesValidation.maxChar]
      "
      @keypress.enter="$emit('save')"
      outline
      :label="option.obrigatorio ? `${option.titulo}*` : option.titulo"
    ></v-text-field>
    <!-- input data -->
    <div v-if="option.tipo === 'data'">
      <v-text-field
        background-color="rgba(25,43,70,0.16)"
        outline
        @keypress.enter="$emit('save')"
        :label="option.obrigatorio ? `${option.titulo} *` : option.titulo"
        :rules="
          option.obrigatorio
            ? [rulesValidation.required, rulesValidation.dateValid]
            : [rulesValidation.dateValid]
        "
        v-model="option.valor"
        :mask="getMask(option.tipo)"
        return-masked-value
      >
      </v-text-field>
    </div>
    <!-- Radio Options -->
    <div v-if="option.tipo === 'multipla_escolha'">
      <span class="item-title" v-if="option.obrigatorio"
        >{{ option.titulo }} *</span
      >
      <span class="item-title" v-else>{{ option.titulo }}</span>
      <v-radio-group
        v-model="option.valor"
        :mandatory="true"
        :rules="option.obrigatorio ? [rulesValidation.required] : []"
      >
        <v-radio
          v-for="(opcao, index) in option.opcoes"
          :key="index"
          :label="opcao"
          color="primary"
          :value="opcao"
        ></v-radio>
      </v-radio-group>
    </div>
    <!-- Caixa Seleção -->
    <div v-if="option.tipo === 'caixa_selecao'" class="pb-4">
      <span class="item-title" v-if="option.obrigatorio"
        >{{ option.titulo }} *</span
      >
      <span v-else>{{ option.titulo }}</span>
      <v-checkbox
        style="height: 25px;"
        v-model="option.valor"
        :rules="option.obrigatorio ? [v => (v && v.length >= 1) || ''] : []"
        color="primary"
        v-for="(opcao, index) in option.opcoes"
        :key="index"
        :label="opcao"
        :value="opcao"
      ></v-checkbox>
    </div>
    <!-- Lista Suspensa -->
    <div v-if="option.tipo === 'lista_suspensa'">
      <v-select
        background-color="rgba(25,43,70,0.16)"
        v-model="option.valor"
        :items="option.opcoes"
        item-text="text"
        item-value="value"
        :label="option.obrigatorio ? `${option.titulo} *` : option.titulo"
        outline
        :rules="option.obrigatorio ? [rulesValidation.required] : []"
      ></v-select>
    </div>

    <div v-if="option.tipo === 'documentos'">
      <v-layout :column="!$vuetify.breakpoint.mdAndUp">
        <v-flex sm12 md4 :class="$vuetify.breakpoint.mdAndUp ? 'pr-2' : ''">
          <v-select
            v-model="selectedDocument"
            :items="getDocumentsItems(option.opcoes)"
            background-color="white"
            class="rounded-lg"
            label="Tipo de Documento"
            outline
            :rules="option.obrigatorio ? [rulesValidation.required] : []"
            @change="handleChangeSelectedDocument"
          ></v-select>
        </v-flex>
        <v-flex
          sm12
          md8
          :class="$vuetify.breakpoint.mdAndUp ? 'pl-2' : 'mt-n4'"
        >
          <v-text-field
            v-if="selectedDocument === 'CPF'"
            ref="ticketName"
            class="rounded-lg"
            v-model="option.valor"
            :label="option.obrigatorio ? `${option.titulo} *` : option.titulo"
            :mask="
              getMask(selectedDocument ? selectedDocument.toLowerCase() : '')
            "
            :rules="
              option.obrigatorio
                ? selectedDocument === 'CPF'
                  ? [rulesValidation.required, cpfRule]
                  : [rulesValidation.required]
                : selectedDocument === 'CPF'
                ? [cpfRule]
                : []
            "
            @keypress="keyPressDocument"
            @keypress.enter="$emit('save')"
            outline
          ></v-text-field>
          <v-text-field
            v-if="selectedDocument !== 'CPF'"
            ref="ticketName"
            class="rounded-lg"
            v-model="option.valor"
            :label="option.obrigatorio ? `${option.titulo} *` : option.titulo"
            :rules="
              option.obrigatorio
                ? selectedDocument === 'CPF'
                  ? [rulesValidation.required, cpfRule]
                  : [rulesValidation.required]
                : selectedDocument === 'CPF'
                ? [cpfRule]
                : []
            "
            @keypress.enter="$emit('save')"
            outline
          ></v-text-field>
        </v-flex>
      </v-layout>
    </div>

    <!-- Resposta Longa -->
    <div v-if="option.tipo === 'resposta_longa'">
      <v-textarea
        background-color="rgba(25,43,70,0.16)"
        outline
        :label="option.obrigatorio ? `${option.titulo} *` : option.titulo"
        auto-grow
        v-model="option.valor"
        :rules="
          option.obrigatorio
            ? [rulesValidation.required, rulesValidation.maxChar]
            : [rulesValidation.maxChar]
        "
      ></v-textarea>
    </div>
    <div id="google-place"></div>
    <div id="google-autocomplete"></div>
    <div v-if="option.tipo === 'localidade'">
      <v-autocomplete
        background-color="rgba(25,43,70,0.16)"
        outline
        :label="option.obrigatorio ? `${option.titulo} *` : option.titulo"
        v-model="option.valor"
        item-text="description"
        :item-value="valueFormated"
        browser-autocomplete="new-password"
        :items="eventPlaces"
        no-data-text="Digite para buscar o local"
        :rules="option.obrigatorio ? [rulesValidation.required] : []"
        :search-input.sync="location"
      ></v-autocomplete>
    </div>

    <!-- Termo Responsabilidade -->
    <div
      v-if="
        option.tipo === 'termo_responsabilidade' || option.tipo === 'paragrafo'
      "
    >
      <span class="mb-4 item-title" v-if="option.obrigatorio"
        >{{ option.titulo }} *</span
      >
      <span class="item-title mb-4" v-else>{{ option.titulo }}</span>
      <div
        class="termo-responsabilidade-item pa-2"
        v-html="option.conteudo"
      ></div>
      <v-checkbox
        v-if="option.obrigatorio && option.tipo !== 'paragrafo'"
        v-model="option.valor"
        :rules="[v => !!v || 'Você precisa aceitar os termos!']"
        color="primary"
        label="Li e aceito os termos"
      ></v-checkbox>
    </div>

    <!-- Upload Arquivos -->
    <div
      v-if="option.tipo === 'upload_arquivo' || option.tipo === 'upload_imagem'"
    >
      <v-text-field
        background-color="rgba(25,43,70,0.16)"
        outline
        :label="option.obrigatorio ? `${option.titulo} *` : option.titulo"
        v-model="option.valor"
        @click="onPickFile(option)"
        @click:append="onPickFile(option)"
        append-icon="publish"
      >
      </v-text-field>
      <!-- Hidden -->
      <input
        type="file"
        @change="onFileSelected"
        style="display: none"
        :id="`fileInput-${option.tipo}`"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import validationMixin from '../../mixins/validationMixin';
export default {
  props: ['option'],
  mixins: [validationMixin],
  data() {
    return {
      selectedOption: null,
      isWaitingNameTicket: false,
      order_hash: null,
      location: '',
      locations: [],
      selectedDocument: null,
      cnpjRule: cnpj => {
        if (cnpj && cnpj.length) {
          cnpj = cnpj.replace(/[^\d]+/g, '');
          if (cnpj === '') return 'CNPJ inválido';

          if (cnpj.length !== 14) return 'CNPJ inválido';

          // Elimina CNPJs invalidos conhecidos
          if (
            cnpj === '00000000000000' ||
            cnpj === '11111111111111' ||
            cnpj === '22222222222222' ||
            cnpj === '33333333333333' ||
            cnpj === '44444444444444' ||
            cnpj === '55555555555555' ||
            cnpj === '66666666666666' ||
            cnpj === '77777777777777' ||
            cnpj === '88888888888888' ||
            cnpj === '99999999999999'
          )
            return 'CNPJ inválido';

          // Valida DVs
          let tamanho = cnpj.length - 2;
          let numeros = cnpj.substring(0, tamanho);
          let digitos = cnpj.substring(tamanho);
          let soma = 0;
          let pos = tamanho - 7;
          for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
          }
          let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
          if (parseInt(resultado) !== parseInt(digitos.charAt(0)))
            return 'CNPJ inválido';

          tamanho = tamanho + 1;
          numeros = cnpj.substring(0, tamanho);
          soma = 0;
          pos = tamanho - 7;
          for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
          }
          resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
          if (parseInt(resultado) !== parseInt(digitos.charAt(1)))
            return 'CNPJ inválido';

          return true;
        } else {
          return true;
        }
      },
      cpfRule: cpf => {
        let numeros;
        let digitos;
        let soma;
        let i;
        let resultado;
        let digitosIguais;
        digitosIguais = 1;
        cpf = cpf.replace(/-|\./g, '');
        if (cpf.length !== 0 && cpf.length < 11) {
          return 'CPF inválido';
        }
        for (i = 0; i < cpf.length - 1; i++) {
          if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
            digitosIguais = 0;
            break;
          }
        }
        if (!digitosIguais) {
          numeros = cpf.substring(0, 9);
          digitos = cpf.substring(9);
          soma = 0;
          for (i = 10; i > 1; i--) {
            soma += numeros.charAt(10 - i) * i;
          }
          resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
          if (resultado !== parseInt(digitos.charAt(0))) {
            return 'CPF inválido';
          }
          numeros = cpf.substring(0, 10);
          soma = 0;
          for (i = 11; i > 1; i--) {
            soma += numeros.charAt(11 - i) * i;
          }
          resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
          if (resultado !== parseInt(digitos.charAt(1))) {
            return 'CPF inválido';
          }
          return true;
        } else return 'CPF inválido';
      },
    };
  },
  mounted() {
    if (this.option && this.option.tipo === 'documentos') {
      let documents = this.getDocumentsItems(this.option.opcoes);

      this.selectedDocument = documents[0];
    }
  },
  watch: {
    location(v) {
      if (v && v.length >= 3) {
        this.searchLocation(v);
      } else this.$store.commit('SET_ALL_EVENT_PLACES', []);
    },
  },
  computed: {
    ...mapGetters(['eventPlaces']),

    counterField() {
      if (
        this.option.tipo === 'nome' ||
        this.option.tipo === 'email' ||
        this.option.tipo === 'resposta_curta' ||
        this.option.tipo === 'resposta_longa'
      )
        return 255;

      return null;
    },
  },
  methods: {
    onPickFile(el) {
      this.selectedOption = el;
      setTimeout(function() {
        document.getElementById(`fileInput-${el.tipo}`).click();
      }, 200);
    },
    getDocumentsItems(options) {
      return options.map(option => {
        if (option === 'rg' || option === 'cpf') return option.toUpperCase();
        else if (option === 'passaporte') return 'Passaporte';
        return option;
      });
    },
    valueFormated(v) {
      let valueReplace = v.description.split(' - ');
      return `${valueReplace[0]}/${valueReplace[1]}/${valueReplace[2]}`;
    },
    async searchLocation(v) {
      await this.$store.dispatch('getGlobalPlaces', v);
    },
    onFileSelected(event) {
      if (this.option.tipo === 'upload_arquivo') {
        this.option.valor = event.target.value;
        this.option.file = event.target.files[0];
      }
      if (this.option.tipo === 'upload_imagem') {
        this.option.valor = event.target.value;
        this.option.image = event.target.files[0];
      }

      this.selectedOption = null;
      this.$forceUpdate();
    },
    keyPressDocument(event) {
      if (
        this.option.tipo === 'documentos' &&
        this.option.valor &&
        this.option.valor.length === 10 &&
        (this.selectedDocument === 'Passaporte' ||
          this.selectedDocument === 'RG')
      )
        event.preventDefault();
    },
    handleChangeSelectedDocument(event) {
      if ((event === 'Passaporte' || event === 'RG') && this.option.valor)
        this.option.valor = this.option.valor.slice(0, 10);
    },
    getMask(el) {
      switch (el) {
        case 'telefone':
          return '(##) #########';
        case 'data':
          return '##/##/####';
        case 'horario':
          return '##:##';
        case 'cnpj':
          return '##.###.###/####-##';
        case 'cpf':
          return '###.###.###-##';
        default:
          return '';
      }
    },
    returnMaked(el) {
      switch (el) {
        case 'telefone':
          return false;
        case 'data':
          return false;
        case 'horario':
          return false;
        case 'rg':
          return false;
        case 'cnpj':
          return true;
        case 'cpf':
          return true;
        default:
          return false;
      }
    },
    async saveNameTicket() {
      this.$emit('save');
    },
  },
};
</script>

<style></style>
